import { Link } from "react-router-dom";
import { Plus, Pencil, Trash2, ExternalLink } from "lucide-react";
import { AdminHead } from "./AdminLayout";
import { api, catLabel, fmtDate, img, useAction, useGet } from "../../lib/api";

export default function AdminArticles() {
  const { data } = useGet("articles", "/articles", { limit: 200 });
  const act = useAction(["articles", "stats"]);
  const remove = (a) => window.confirm(`Hapus artikel "${a.title}"?`) && act(() => api.delete(`/articles/${a.id}`), "Artikel dihapus");
  return (
    <>
      <AdminHead title="Artikel Edukasi" desc="Tulis dan kelola artikel Pojok Edukasi.">
        <Link to="/admin/artikel/baru" className="btn-gold" data-testid="article-add-button"><Plus className="h-4 w-4" /> Tulis Artikel</Link>
      </AdminHead>
      <div className="space-y-3">
        {(data || []).map((a) => (
          <div key={a.id} className="flex flex-wrap items-center gap-4 rounded-2xl border bg-white p-4" data-testid={`admin-article-row-${a.id}`}>
            <img src={img(a.thumbnail_url)} alt="" className="h-16 w-24 rounded-xl object-cover" />
            <div className="min-w-[200px] flex-1">
              <p className="font-semibold">{a.title}</p>
              <p className="text-xs text-[var(--ink)]/60">{catLabel(a.category)} · {fmtDate(a.created_at)}</p>
            </div>
            <a href={`/edukasi/${a.slug}`} target="_blank" rel="noreferrer" className="rounded-full p-2 hover:bg-[var(--cream)]" data-testid={`article-view-${a.id}`}><ExternalLink className="h-4 w-4" /></a>
            <Link to={`/admin/artikel/edit/${a.slug}`} className="rounded-full p-2 hover:bg-[var(--cream)]" data-testid={`article-edit-${a.id}`}><Pencil className="h-4 w-4" /></Link>
            <button onClick={() => remove(a)} className="rounded-full p-2 text-red-600 hover:bg-red-50" data-testid={`article-delete-${a.id}`}><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
        {data?.length === 0 && <p className="text-[var(--ink)]/60">Belum ada artikel.</p>}
      </div>
    </>
  );
}
